/**
 * Copyright (c) 2019 2020 2021 2022 AIGIA. All Rights Reserved.
 * see license.txt
 */

"use strict";

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {FormsModule, ReactiveFormsModule} from "@angular/forms";

import {MatFormFieldModule} from "@angular/material/form-field";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatSelectModule} from "@angular/material/select";
import {MatIconModule} from "@angular/material/icon";
import {MatDialogModule} from "@angular/material/dialog";
import {MatCardModule} from "@angular/material/card";
import {MatDividerModule} from "@angular/material/divider";
import {MatInputModule} from "@angular/material/input";
import {MatButtonModule} from "@angular/material/button";
import {MatSnackBarModule} from "@angular/material/snack-bar";

import {FlexLayoutModule} from "@angular/flex-layout";
import {TopComponent} from "./top.component";
import {NewsModule} from 'src/app/aigia/news/news.module';

import {AigiaAuthModule} from "../auth/aigia-auth.module";

import {TranslateModule} from "@ngx-translate/core";

@NgModule({
	declarations: [
		TopComponent,
	],
	imports: [
		CommonModule,
		FlexLayoutModule,
		NewsModule,
		CommonModule,
		FormsModule,
		FlexLayoutModule,
		MatDividerModule,
		MatButtonModule,
		MatCheckboxModule,
		MatDialogModule,
		MatIconModule,
		MatInputModule,
		MatSnackBarModule,
		MatFormFieldModule,
		MatSelectModule,
		ReactiveFormsModule,
		MatCardModule,
		AigiaAuthModule,

		TranslateModule

	],
	exports: [],
	bootstrap: [],
})

export class TopModule {
}
